fragment LinkFragment on HyperLinkInterface {
  type
  element {
    __typename
    slug
    title
    uri
  }
  text
  target
  url
}
